import React, { useEffect } from 'react';
import Layout from '../components/layout/layout';
import HeroPricing from '../components/pricing/hero'; 

export default function PricingPage({ initialData }) {
  useEffect(() => {
    // Get title from initialData if available, otherwise use fallback
    const pageTitle = initialData?.meta?.title || 'WymBee Pricing - Flexible Solutions';
    document.title = pageTitle;
  }, [initialData]);

  return (
    <Layout initialData={initialData}>
      <HeroPricing />
    </Layout>
  );
}